import React, { Component } from 'react';

import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import AntLocalization from '../utils/AntLocalization';
import AntProcessingButton from '../components/AntProcessingButton';

export default class AntInfoPanel extends Component {
    render() {
        var hasDetails = this.props.infos instanceof Array && this.props.infos.length > 0;
        var infoDetails = (hasDetails ? this.props.infos.map((e) => AntLocalization.translateText(e)).join('\n') : '').split('\n');
        var infoId = this.props.id;
        var infoText = this.props.text;
        infoText = AntLocalization.translateText(infoText);

        return (
            <React.Fragment>
                {infoText && (
                    <div className="ant-info-pannel">
                        <Box direction="row" height="100%" width="100%">
                            <BoxItem baseSize={40}>
                                <Button
                                    className="ant-grid-icon ant-icon-info"
                                    id={infoId}
                                    type="normal"
                                    stylingMode="text"
                                    focusStateEnabled={false}
                                    hoverStateEnabled={false}
                                    activeStateEnabled={false}
                                >
                                    <i className={'dx-icon dx-icon-info'}></i>
                                </Button>
                            </BoxItem>

                            <BoxItem ratio={1}>
                                <span className="ant-info-text">{infoText}</span>
                            </BoxItem>
                            {this.props.showYes && (
                                <BoxItem baseSize={80}>
                                    <AntProcessingButton
                                        actionId={infoId}
                                        stylingMode={"text"}
                                        text={AntLocalization.translateText({ vi: 'Đồng Ý', en: 'Agree', fr: 'Accepter', es: 'Aceptar', id: 'Setuju', ja: '同意', zh: '同意', ko: '동의', hi: 'सहमत', ar: 'موافق' })}
                                        width={70}
                                        onClick={this.props.onAgreeClick}
                                    />
                                </BoxItem>
                            )}
                        </Box>

                        {hasDetails && (
                            <Tooltip
                                target={`#${infoId}`}
                                className="ant-tooltip"
                                hideEvent="mouseleave"
                                showEvent={{
                                    name: 'mouseenter dxclick keyup'
                                }}
                                hideOnOutsideClick={true}
                            >
                                {infoDetails.map((item, key) => {
                                    if (key < infoDetails.length - 1)
                                        return (
                                            <React.Fragment>
                                                <label key={key}>{item}</label> <br />
                                            </React.Fragment>
                                        );
                                    else return <label key={key}>{item}</label>;
                                })}
                            </Tooltip>
                        )}
                    </div>
                )}
            </React.Fragment>
        );
    }
}
